import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import cx from 'classnames';
var WizardCrumb = createComponent({
  displayName: 'WizardCrumb',
  defaultProps: {
    index: undefined,
    active: false,
    hidden: false
  },
  propTypes: {
    index: PropTypes.number,
    active: PropTypes.bool,
    hidden: PropTypes.bool
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var _cls = cx('wizard-ui-crumb', {
      'wizard-ui-crumb--hidden': p.hidden,
      'wizard-ui-crumb--active': p.active,
      'wizard-ui-crumb--inverted': p.isInverted
    });

    return /*#__PURE__*/React.createElement("div", {
      className: _cls
    }, p.children);
  }
});
export default WizardCrumb;
//# sourceMappingURL=wizard-crumb.js.map